// extracted by mini-css-extract-plugin
module.exports = {"error":"#f49696"};